module.exports = "mutation updateCustomerPassword($current:String!,$updated:String!){updateCustomerPassword(current:$current,updated:$updated){id}}"